<div class="container-fluid">
    <div class="row">
        <div class="col-lg-2">
            <img src="assets/img/auri.png" width="200px">
        </div>
        <div class="col-lg-2"></div>
        <div class="col-lg-4">
            <br><br>
            <p class="center">Por favor ingresa tu número de celular:</p>
            <input type="text" placeholder="Celular" [(ngModel)]="celular" class="form-control"><br>
            <p class="center"><button type="button" class="btn btn-primary" (click)="sendMessage();">Obtener contraseña</button></p>
            <div [innerHTML]="message"></div>
        </div>
        <div class="col-lg-4"></div>
        <div class="col-lg-4"></div>
    </div>
    
</div>